<div class="container clinic-layout-container" [class.review-page]="reviewPage">
    <h1 [style.text-align]="titleCenter ? 'center': 'left'">{{title}}</h1>
    <div class="consultation-container">
        <ng-content></ng-content>
    </div>
</div>